import { useState, useEffect } from 'react';
import { useAuthFetch } from '@/hooks/useAdmin';
import { Check, X, Trash2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsSubmissions() {
  const authFetch = useAuthFetch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  async function load() {
    try { const r = await authFetch(`${API}/admin/news-submissions`); if (r.ok) { const d = await r.json(); setItems(d.submissions || []); } }
    catch (e) { console.error(e); } finally { setLoading(false); }
  }

  async function approve(id) {
    const r = await authFetch(`${API}/admin/news-submissions/${id}/approve`, { method: 'POST' });
    if (r.ok) { toast.success('Članak kreiran kao skica'); load(); } else { toast.error('Greška'); }
  }

  async function reject(id) {
    if (!window.confirm('Obrisati predanu vijest?')) return;
    await authFetch(`${API}/admin/news-submissions/${id}`, { method: 'DELETE' });
    load();
  }

  if (loading) return <div className="flex items-center justify-center h-full"><Loader2 className="animate-spin text-zinc-500" /></div>;

  return (
    <div className="p-6 max-w-6xl" data-testid="news-submissions-page">
      <h1 className="text-2xl font-semibold mb-6">Predane vijesti</h1>
      {items.length === 0 ? (
        <div className="text-center py-12 text-zinc-500">Nema predanih vijesti</div>
      ) : (
        <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-zinc-800 text-zinc-500 text-left">
              <th className="px-4 py-3 font-medium">Datum</th>
              <th className="px-4 py-3 font-medium">Naslov</th>
              <th className="px-4 py-3 font-medium">E-mail</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium w-28">Akcije</th>
            </tr></thead>
            <tbody>
              {items.map(s => (
                <tr key={s.id} className="border-b border-zinc-800/50 hover:bg-zinc-800/30">
                  <td className="px-4 py-3 text-zinc-400 text-xs">{new Date(s.created_at).toLocaleDateString('hr')}</td>
                  <td className="px-4 py-3 text-zinc-200">{s.title}</td>
                  <td className="px-4 py-3 text-zinc-400 text-xs">{s.contact_email}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-1.5 py-0.5 rounded ${s.status === 'approved' ? 'bg-emerald-500/20 text-emerald-400' : s.status === 'pending' ? 'bg-amber-500/20 text-amber-400' : 'bg-zinc-700 text-zinc-400'}`}>{s.status}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex gap-1">
                      {s.status === 'pending' && <button onClick={() => approve(s.id)} className="p-1.5 text-zinc-500 hover:text-emerald-400" title="Odobri"><Check size={14} /></button>}
                      <button onClick={() => reject(s.id)} className="p-1.5 text-zinc-500 hover:text-red-400" title="Obriši"><Trash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
